import React, { useState } from 'react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import ContactModal from './ContactModal';
import { Sheet, SheetContent } from './ui/sheet';
import { Menu, X } from 'lucide-react';

import './Header.css';

export default function Header({ scrolled, isWrityPage = false, alwaysBorder = false, isSubpage = false }) {
  const navigate = useNavigate();
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const showBorder = Boolean(scrolled) || alwaysBorder;
  const showHomeLink = isWrityPage || isSubpage;

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? 'bg-white/80 backdrop-blur-xl' : 'bg-transparent'
        } ${showBorder ? 'border-b border-gray-200/50' : ''}`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex items-center justify-between">
          <div 
            className="logo cursor-pointer flex items-center gap-3" 
            onClick={() => navigate('/')}
          >
            {/* Logo container */}
            <div className="flex items-center justify-center">
              <img
                src="/Logo.svg"
                alt="Longfloat Logo"
                className="w-8 h-8 object-contain"
              />
            </div>
            <span className="text-2xl font-light tracking-tight text-gray-900">Longfloat</span>
          </div>
          
          <nav className="bp-desktop-nav items-center gap-8">
            {!showHomeLink && (
              <>
                <a
                  href="#products"
                  className="text-sm text-gray-600 hover:text-gray-900 transition-colors duration-300 hover:-translate-y-0.5 inline-block"
                >
                  Products
                </a>
              </>
            )}
            {showHomeLink && (
              <a
                onClick={() => navigate('/')}
                className="text-sm text-gray-600 hover:text-gray-900 transition-colors duration-300 hover:-translate-y-0.5 inline-block cursor-pointer"
              >
                Back to Home
              </a>
            )}
            <Button
              variant="outline"
              className="text-sm border-gray-200 hover:border-gray-900 hover:bg-gray-900 hover:text-white transition-all duration-300 rounded-lg"
              onClick={() => setIsContactOpen(true)}
            >
              Contact
            </Button>
          </nav>

        </div>
      </header>

      <button
        type="button"
        className="bp-mobile-only headerHamburgerButton text-slate-900"
        aria-label="Open menu"
        onClick={() => setMobileMenuOpen((v) => !v)}
      >
        {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
      </button>

      <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
        <SheetContent side="right">
          <div className="flex flex-col gap-4">
            {!showHomeLink ? (
              <a
                href="#products"
                className="text-base font-medium text-slate-600 hover:text-gray-900 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Products
              </a>
            ) : (
              <button
                type="button"
                className="text-base font-medium text-slate-600 hover:text-gray-900 transition-colors text-left"
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate('/');
                }}
              >
                Back to Home
              </button>
            )}

            <div className="pt-2 border-t border-slate-200/70" />

            <Button
              variant="outline"
              className="text-sm border-gray-200 hover:border-gray-900 hover:bg-gray-900 hover:text-white transition-all duration-300 rounded-lg w-full"
              onClick={() => {
                setMobileMenuOpen(false);
                setIsContactOpen(true);
              }}
            >
              Contact
            </Button>
          </div>
        </SheetContent>
      </Sheet>

      <ContactModal 
        isOpen={isContactOpen} 
        onClose={() => setIsContactOpen(false)} 
      />
    </>
  );
}
